@if (evidenceTableData().length > 0) {
  <div class="taint-evidence-card">
    <div class="taint-evidence-card-title">
      {{ 'aiInLineControlPage.evidenceTitle' | labelsProvider }}
    </div>

    @if (evidenceFlowData().length > 0) {
      <div class="evidence-flow">
        <div class="evidence-flow-header">{{ 'aiInLineControlPage.evidenceFlowTitle' | labelsProvider }}</div>
        <div class="evidence-flow-content">
          @for (flowItem of evidenceFlowData(); track flowItem.key; let isLast = $last) {
            <span class="evidence-flow-item">{{ flowItem.label }}</span>
            @if (!isLast) {
              <lucide-icon name="arrow-right" class="evidence-flow-arrow" [size]="16" [strokeWidth]="2"> </lucide-icon>
            }
          }
        </div>
      </div>
    }

    <div class="evidence-table">
      <mat-table [dataSource]="evidenceDataSource()" class="evidence-mat-table">
        <ng-container matColumnDef="connector">
          <mat-header-cell *matHeaderCellDef class="connector-header">{{
            'aiInLineControlPage.evidenceConnectorColumn' | labelsProvider
          }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="connector-cell">
            {{ row.connector }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="tool">
          <mat-header-cell *matHeaderCellDef class="tool-header">{{
            'aiInLineControlPage.evidenceToolColumn' | labelsProvider
          }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="tool-cell">
            {{ row.tool }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="label">
          <mat-header-cell *matHeaderCellDef class="label-header">{{
            'aiInLineControlPage.evidenceLabelColumn' | labelsProvider
          }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="label-cell">
            {{ row.label }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="timestamp">
          <mat-header-cell *matHeaderCellDef class="timestamp-header">{{
            'aiInLineControlPage.evidenceTimestampColumn' | labelsProvider
          }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="timestamp-cell">
            {{ row.timestamp }}
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
    </div>
  </div>
}
